import type { KeyCombination, ShortcutTarget, KeyboardShortcuts } from './types'

const shortcuts: KeyboardShortcuts = {}

const normalizeKeyCombination = (combination: string): string => {
  return combination
    .split('+')
    .map(key => key.trim().toLowerCase())
    .sort()
    .join('+')
}

const isKeyCombinationPressed = (e: KeyboardEvent, combination: string): boolean => {
  const keys = combination.split('+')
  const modifiers = {
    ctrl: e.ctrlKey,
    alt: e.altKey,
    shift: e.shiftKey,
    meta: e.metaKey
  }

  for (const key of keys) {
    const lowerKey = key.toLowerCase()
    if (lowerKey in modifiers) {
      if (!modifiers[lowerKey as keyof typeof modifiers]) {
        return false
      }
    } else if (lowerKey !== e.key.toLowerCase()) {
      return false
    }
  }

  return true
}

export const navigateFocus = (targetId: string, selectedInput: boolean = false) => {
  if (!targetId) return
  const targetEl = document.getElementById(targetId)
  if (targetEl) {
    targetEl.focus();
    if(selectedInput) {
      targetEl.select();
    }
  }
}

export const handleKeyDown = (e: KeyboardEvent) => {
  const target = e.target as HTMLElement
  const isInputElement = target.tagName === 'INPUT' ||
    target.tagName === 'TEXTAREA' ||
    target.tagName === 'SELECT' ||
    target.isContentEditable

  if (isInputElement && !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
    return
  }

  for (const [combination, targetId] of Object.entries(shortcuts)) {
    if (isKeyCombinationPressed(e, combination)) {
      e.preventDefault()
      navigateFocus(targetId)
      return
    }
  }
}

export const addKeyboardShortcut = (combination: KeyCombination, targetId: ShortcutTarget) => {
  const normalizedCombination = normalizeKeyCombination(combination)
  shortcuts[normalizedCombination] = targetId
}

export const removeKeyboardShortcut = (combination: KeyCombination) => {
  const normalizedCombination = normalizeKeyCombination(combination)
  delete shortcuts[normalizedCombination]
}

export const getKeyboardShortcuts = (): KeyboardShortcuts => {
  return { ...shortcuts }
}